<template>
    <div>
        <template v-if="isAvailable">
            <VoiceServices v-bind="data"
                           :meta="meta"
                           :voice-data="data"
                           :is-selected="isSelected"
                           :professional="professional"
                           @select="setVoiceOptions($event)"
                           :get-service-price="getServicePrice"
                           :has-selected-self-install="hasSelectedSelfInstall"
                           @set-install-type="submitInstallationFulfillment($event)"
            />
            <VoiceDeclineService :self-install="selfInstall"
                                 @decline="declineService($event)"
                                 :has-declined="voiceOptions.declined"
                                 :has-selected-pro-install="hasSelectedProInstall"
                                 @set-install-type="submitInstallationFulfillment($event)"
            />
        </template>
        <template v-else>
            <div class="buyflow-panel">
                <div class="text-lg desktop:text-xl font-bold text-red-400 mb-4 flex items-center">
                    <IconCircleXmark class="mr-1" />
                    Phone service is not available
                </div>
                <div>
                    Because you are using your own internet equipment, we are unable to provide you with phone service.
                    To add phone service, please return to the
                    <RouterLink :to="{ name: 'buyflow-internet' }"
                                class="text-salmon
                                       underline">
                        Internet & WiFi Options page
                    </RouterLink>
                    and add a Breezeline-provided internet equipment to your order.
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import { mapState, mapGetters, mapActions } from 'vuex'
    import IconCircleXmark from "@/atoms/icons/IconCircleXmark"
    import VoiceServices from '~/Buyflow/components/VoiceServices'
    import VoiceDeclineService from '~/Buyflow/components/VoiceDeclineService'

    export default {
        name: 'VoicePage',
        components: {
            VoiceServices,
            VoiceDeclineService,
            IconCircleXmark,
        },
        computed: {
            ...mapState({
                meta: state => state.meta,
                data: state => state.Buyflow.voice.data,
                voiceOptions: state => state.Buyflow.voice.voiceOptions,
                installData: state => state.Buyflow.finalize.installData,
            }),
            ...mapGetters({
                isHidden: 'Buyflow/voice/isHidden',
                isMinimal: 'Buyflow/voice/isMinimal',
                isSelected: 'Buyflow/voice/isSelected',
                getServicePrice: 'Buyflow/voice/getServicePrice',
                hasSelectedProInstall: 'Buyflow/finalize/hasSelectedProInstall',
                hasSelectedSelfInstall: 'Buyflow/finalize/hasSelectedSelfInstall',
            }),
            professional() {
                return this.installData?.proInstall ? this.installData.proInstall : ''
            },
            selfInstall() {
                return this.installData?.selfInstallKit ? this.installData.selfInstallKit : ''
            },
            isAvailable() {
                // NOTE not sure if this check should be here (name string is tied to API2, not this app)
                return !this.$store.getters['Buyflow/internet/isEquipmentSelected']({ name: 'Customer Owned Modem' })
            },
        },
        mounted() {
            this.pushEvent('checkout_flow', {
                'flow_step_name': 'customize home phone',
                'flow_step_number': '3'
            });
            this.setSessionStatus({ session_status: 3, })
            this.setCurrentStep([3,'voice page'])
            if (this.isHidden){
                this.$router.push({ name: 'buyflow-installation'})
            }
        },
        methods: {
            ...mapActions({
                setCurrentStep: 'Buyflow/setCurrentStep',
                setSessionStatus: 'Buyflow/setSessionStatus',
                declineService: 'Buyflow/voice/declineService',
                setVoiceOptions: 'Buyflow/voice/setVoiceOptions',
                submitInstallationFulfillment: 'Buyflow/finalize/submitInstallationFulfillment',
            }),
        },
    }
</script>
